var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotFound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 178,
    viewBox: "0 0 200 178",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.462,
    cy: 86.7974,
    rx: 86.3995,
    ry: 86.2974,
    fill: "#E6EEFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M109.345 128.021L89.2972 130.78L73.6765 128.021C75.4307 154.934 50.2871 167.22 50.2871 167.22H91.5526H132.735C132.735 167.22 107.591 154.934 109.345 128.021Z",
    fill: "#E5EAF2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2967 130.696L73.6759 127.938C74.1771 135.376 72.59 141.645 70.084 146.91L116.445 152.844C112.018 146.659 108.676 138.385 109.345 127.938L89.2967 130.696Z",
    fill: "#94A4C4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M179.43 173.07C179.43 175.494 177.425 177.5 175.003 177.5H8.77103C6.34856 177.5 4.34375 175.494 4.34375 173.07C4.34375 170.647 6.34856 168.641 8.77103 168.641H175.086C177.509 168.641 179.43 170.647 179.43 173.07Z",
    fill: "#E5EAF2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M136.912 168.641C136.912 171.064 134.908 173.07 132.485 173.07H51.6245C49.2021 173.07 47.1973 171.064 47.1973 168.641C47.1973 166.217 49.2021 164.211 51.6245 164.211H132.485C134.991 164.211 136.912 166.217 136.912 168.641Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M188.701 144.152C187.782 151.591 181.016 156.773 173.582 155.853L11.8608 135.209C4.42631 134.29 -0.752773 127.52 0.166097 120.082L11.3596 32.4077C12.2785 25.0527 19.0447 19.7873 26.4792 20.7067L188.2 41.3506C195.551 42.2699 200.814 49.0398 199.895 56.4783L188.701 144.152Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M188.201 41.3506L26.3966 20.7067C19.0456 19.7873 12.2794 24.9692 11.277 32.4077L0.0835323 119.998C0.0835323 120.165 0.0835335 120.416 0 120.583L188.452 144.654C188.452 144.487 188.535 144.319 188.535 144.069L199.729 56.4783C200.815 49.1234 195.552 42.3535 188.201 41.3506Z",
    fill: "#61A9FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4952 31.7529L7.89648 114.911L182.494 137.188L193.092 54.0295L18.4952 31.7529Z",
    fill: "#1F2738"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M7.85125 59.9886L2.00391 105.539L99.4876 30.0675L53.9618 24.3005L7.85125 59.9886Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M192.211 42.5207C190.958 41.9356 189.621 41.5177 188.201 41.3506L123.462 33.0763L1.41992 127.604C3.34119 131.615 7.18374 134.541 11.8616 135.126L63.9866 141.812L192.211 42.5207Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M196.971 79.2952L198.057 70.603L100.072 146.409L108.76 147.495L196.971 79.2952Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8535_87396)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.5363 80.6835C51.1352 81.7348 49.1035 81.5246 48.0526 80.1229C47.0017 78.7212 47.2119 76.6888 48.613 75.6375L74.3245 55.6637C75.7257 54.6124 77.7574 54.8227 78.8082 56.2243C79.8591 57.626 79.6489 59.6584 78.2478 60.7097L52.5363 80.6835Z",
    fill: "#E6EEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9365 79.0716C76.9874 80.4733 76.7772 82.5057 75.376 83.557C73.9749 84.6082 71.9432 84.398 70.8923 82.9963L50.9256 57.2756C49.8748 55.8739 50.0849 53.8415 51.4861 52.7902C52.8873 51.739 54.919 51.9492 55.9698 53.3509L75.9365 79.0716Z",
    fill: "#E6EEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.57 90.285C126.168 91.3362 124.137 91.126 123.086 89.7243C122.035 88.3226 122.245 86.2902 123.646 85.239L149.428 65.2651C150.829 64.2138 152.861 64.4241 153.912 65.8258C154.962 67.2274 154.752 69.2599 153.351 70.3111L127.57 90.285Z",
    fill: "#E6EEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.97 88.6731C152.021 90.0748 151.81 92.1072 150.409 93.1585C149.008 94.2097 146.976 93.9995 145.925 92.5978L125.959 66.807C124.908 65.4053 125.118 63.3729 126.519 62.3216C127.92 61.2704 129.952 61.4806 131.003 62.8823L150.97 88.6731Z",
    fill: "#E6EEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.895 113.062C108.934 112.782 107.533 111.03 107.743 108.997C108.513 102.76 104.1 97.0831 97.9345 96.3122C91.6993 95.5413 86.0246 99.9565 85.2539 106.124C84.9737 108.086 83.2222 109.488 81.1905 109.278C79.2289 108.997 77.8277 107.245 78.108 105.213C79.369 95.0507 88.6868 87.8321 98.8453 89.1637C109.004 90.4952 116.22 99.7463 114.889 109.908C114.678 111.941 112.927 113.343 110.895 113.062Z",
    fill: "#E6EEFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8535_87396"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 107.189,
    height: 61.0429,
    fill: "white",
    transform: "translate(47.3516 52.0894)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/NotFound.494af58a5b46ec6fdf1c212a9766d901.svg";
export { ForwardRef as ReactComponent };